module.exports = __webpack_public_path__ + "static/media/thik thau ma rang bharau.651c5c8a.wav";